
import React from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/odometer.min.css';
import '../assets/css/style.css';
import '../assets/css/animate.min.css';
import '../assets/css/swiper.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/hamburger-menu.css';

 
function Home (){
    return <div></div>
}
 
export default Home;